import { Phone, Mail, MapPin, User, Lock } from 'lucide-react'

interface Vendor {
  name: string
}

interface ContactTabProps {
  address?: string
  address_area?: string
  vendor?: Vendor
}

/** Post-booking contact — no phone/email on public listing pages. */
const ContactTab = ({ address, address_area, vendor }: ContactTabProps) => {
  return (
    <div>
      <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-3 sm:mb-4">Host & check-in</h3>
      <div className="space-y-4">
        <div className="flex items-start gap-3 rounded-xl bg-gray-50 p-4">
          <Lock className="h-5 w-5 text-primary-500 shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-medium text-gray-900">Contact details unlock after booking</p>
            <p className="text-xs sm:text-sm text-gray-600 mt-1">
              Phone and email are never shown on public listings. Complete your reservation to receive host
              contact and the full address.
            </p>
          </div>
        </div>

        {(address_area || address) && (
          <div className="flex items-start gap-2.5 sm:gap-3">
            <MapPin className="h-4 w-4 sm:h-5 sm:w-5 text-primary-500 flex-shrink-0 mt-0.5" />
            <span className="text-sm sm:text-base text-gray-700">{address_area || address}</span>
          </div>
        )}

        {vendor && (
          <div className="mt-2 p-3 sm:p-4 bg-gray-50 rounded-lg">
            <h4 className="font-semibold text-gray-900 mb-2 text-sm sm:text-base">Hosted by</h4>
            <div className="flex items-center gap-2.5 sm:gap-3">
              <User className="h-4 w-4 text-primary-500 flex-shrink-0" />
              <span className="text-sm sm:text-base text-gray-700">{vendor.name}</span>
            </div>
          </div>
        )}

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 opacity-60">
          <div className="flex items-center gap-2 text-sm text-gray-500">
            <Phone className="h-4 w-4" />
            <span>Hidden until booked</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-500">
            <Mail className="h-4 w-4" />
            <span>Hidden until booked</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactTab
